import styled from 'foundations-theming-specialty/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { BREEZE_TOOLTIP_DELAY } from 'chatspot-core/constants/Delays';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledBadge = styled(UIBadge).withConfig({
  displayName: "AIBadge__StyledBadge",
  componentId: "oafpxv-0"
})(["background:transparent;border:none;padding:", ";height:", ";width:", ";"], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['500'], ({
  theme
}) => theme.space['800']);
const IconWrapper = styled.span.withConfig({
  displayName: "AIBadge__IconWrapper",
  componentId: "oafpxv-1"
})(["line-height:", ";margin-right:", ";vertical-align:top;transform:translateY(1px);span{text-transform:none;}"], ({
  theme
}) => theme.typography['heading-100'].lineHeight, ({
  theme
}) => theme.space['50']);
const ContentWrapper = styled.div.withConfig({
  displayName: "AIBadge__ContentWrapper",
  componentId: "oafpxv-2"
})(["", ""], ({
  $use,
  theme
}) => {
  const isOutlined = $use === 'outlined';
  return Object.assign({
    alignItems: 'center',
    background: theme.color['breeze-fill-special-btn-alt-default'],
    border: 'none',
    borderRadius: theme.borderRadius['200'],
    color: theme.color['fill-surface-default'],
    display: 'flex',
    fontWeight: theme.typography['body-100'].fontWeight,
    height: theme.space['500'],
    justifyContent: 'center',
    padding: theme.space['0'],
    userSelect: 'none',
    width: theme.space['800'],
    // To override the icon sizes inherited from foundations Button.tsx
    // Temporary fix until we update this component to foundations components
    // TODO - remove this override once transitioned to foundations components
    'svg[data-icon-name]': {
      blockSize: `${theme.space['200']}`,
      width: `${theme.space['200']}`
    }
  }, isOutlined && {
    background: theme.color['breeze-fill-badge-default'],
    border: `1px solid ${theme.color['border-core-default']}`,
    color: theme.color['breeze-icon-feedback-default'],
    fontSize: `${theme.typography['detail-100'].fontSize}`,
    // To override the icon sizes inherited from foundations Button.tsx
    // Temporary fix until we update this component to foundations components
    // TODO - remove this override once transitioned to foundations components
    'svg[data-icon-name]': {
      blockSize: `${theme.space['300']}`,
      width: `${theme.space['300']}`
    },
    '&:hover': {
      background: theme.color['breeze-fill-special-btn-alt-default'],
      border: 'transparent',
      color: theme.color['fill-surface-default'],
      cursor: 'pointer'
    }
  });
});
export const AIBadgeIcon = ({
  use = 'filled'
}) => {
  return /*#__PURE__*/_jsx(StyledBadge, {
    children: /*#__PURE__*/_jsxs(ContentWrapper, {
      $use: use,
      children: [/*#__PURE__*/_jsx(IconWrapper, {
        children: /*#__PURE__*/_jsx(BreezeSingleStarIcon, {})
      }), /*#__PURE__*/_jsx("span", {
        children: "AI"
      })]
    })
  });
};
export const AIBadge = ({
  tooltip
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    delay: BREEZE_TOOLTIP_DELAY,
    title: tooltip || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "aiComponentsUiLibrary.components.aiBadge.tooltip"
    }),
    children: /*#__PURE__*/_jsx(AIBadgeIcon, {})
  });
};